import { Routes, Route } from 'react-router-dom';
import FromApp from './pages/FromApp';
import Publish from './pages/Publish';
import ProjectDetail from './pages/ProjectDetail';
import Home from './pages/Home';
import UserProfile from './pages/UserProfile';
import NotFound from './pages/NotFound';
import Birthday from './pages/Birthday';
import Guardian from './pages/Guardian';
import EditProject from './pages/EditProject';
import EditProfile from './pages/EditProfile';
import EmbedPreview from './pages/EmbedPreview';
import Notifications from './pages/Notifications';
import NotificationDetail from './pages/NotificationDetail';

// Week 1 末路由集合.
// Week 2 起加: /login, /me/* (我的项目/收藏/积分), /search, /guardian-bind
export default function App() {
  return (
    <Routes>
      {/* 首页 (Week 2 接 list-projects) */}
      <Route path="/" element={<Home />} />

      {/* 入口:Studio handoff 落地页 */}
      <Route path="/from-app" element={<FromApp />} />

      {/* 发布前:补填生日 + 家长授权 */}
      <Route path="/birthday" element={<Birthday />} />
      <Route path="/guardian" element={<Guardian />} />

      {/* 发布表单 */}
      <Route path="/publish" element={<Publish />} />

      {/* 项目详情 */}
      <Route path="/p/:shortId" element={<ProjectDetail />} />

      {/* 作者编辑作品 */}
      <Route path="/edit/:shortId" element={<EditProject />} />

      {/* 用户主页 */}
      <Route path="/u/:shortId" element={<UserProfile />} />

      {/* 编辑个人资料 */}
      <Route path="/settings/profile" element={<EditProfile />} />

      {/* 审核预览精简页(后台 iframe 嵌入用,无壳) */}
      <Route path="/embed/:shortId" element={<EmbedPreview />} />

      {/* 独立消息中心页 */}
      <Route path="/notifications" element={<Notifications />} />
      {/* 单条消息详情页 */}
      <Route path="/notifications/:id" element={<NotificationDetail />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
